import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-toolbar-menu',
  templateUrl: './toolbar-menu.component.html',
  styleUrls: ['./toolbar-menu.component.css']
})
export class ToolbarMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-menu/toolbar-menu.component.ts